export default "__VITE_ASSET__DN21VcGd__"